import { useState } from 'react'
import styles from './FAQAccordion.module.scss'

export default function FAQAccordion({ heading = 'FAQ', items = [] }) {
  const [openIndex, setOpenIndex] = useState(null)

  if (!items.length) return null

  const toggle = (index) => setOpenIndex((current) => (current === index ? null : index))

  return (
    <section className={styles.faq}>
      {heading && <h2 className={styles.heading}>{heading}</h2>}

      <ul className={styles.list}>
        {items.map((item, index) => {
          const isOpen = openIndex === index
          const panelId = `faq-panel-${index}`
          const buttonId = `faq-button-${index}`

          return (
            <li key={index} className={styles.item}>
              <button
                id={buttonId}
                type="button"
                className={styles.trigger}
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => toggle(index)}
              >
                <span className={styles.question}>{item.question}</span>
                <span className={styles.icon} aria-hidden="true">
                  {isOpen ? '−' : '+'}
                </span>
              </button>

              <div id={panelId} role="region" aria-labelledby={buttonId} className={styles.panel} hidden={!isOpen}>
                <div className={styles.answer} dangerouslySetInnerHTML={{ __html: item.answer }} />
              </div>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
